import { produce } from 'immer';

import { BUSINESS_DAYS_ACTION_TYPE } from '../actions';

const initialState = {
  businessDays: {},
  potentialBusinessDays: [],
};

const businessDaysReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case BUSINESS_DAYS_ACTION_TYPE.GET_BUSINESS_DAYS:
      case BUSINESS_DAYS_ACTION_TYPE.UPDATE_BUSINESS_DAYS:
        draft.businessDays = payload;
        break;

      case BUSINESS_DAYS_ACTION_TYPE.GET_POTENTIAL_BUSINESS_DAYS:
        draft.potentialBusinessDays = payload;
        break;

      default:
        return state;
    }
  });

export default businessDaysReducer;
